<template>
    <div>
        <list-cities @update="update" @create="create()" @remove="remove"/>
        <form-gestion
                :modal="modal"
                :external-action="evento"
                @close="close"
        />
    </div>
</template>

<script>
import listCities from './list'
import formGestion from './formManager'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'city',
  components: {
    formGestion,
    listCities
  },
  data () {
    return {
      modal: false,
      evento: ''
    }
  },
  mounted () {
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: state => state.events.status
    })
  },
  methods: {
    ...mapActions({
      clear: 'cities/setClearOne',
      initProvinces: 'provinces/setInit',
      init: 'cities/setInit',
      initUsers: 'users/setInit',
      setStatus: 'events/setStatus'
    }),
    create () {
      this.modal = true
      this.evento = 'create'
    },
    update () {
      this.modal = true
      this.evento = 'update'
    },
    remove () {
      this.modal = true
      this.evento = 'delete'
    },
    close () {
      this.modal = false
      this.evento = ''
      this.clear()
    },
    async initData () {
      await Promise.all([
        this.init(),
        this.initProvinces(),
        this.initUsers()
      ])
    }
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    }
  }
}
</script>
